export enum MapsCopiedStatus {
    Completed = "Completed",
    Processing = "Processing",
    ValidationError = "ValidationError"
}